"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RTL 2021 API (2026.08.10.)
 * RTL 2021 API (2026.08.10.)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rtlteam@konzorcia.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CastFromJSON = CastFromJSON;
exports.CastFromJSONTyped = CastFromJSONTyped;
exports.CastToJSON = CastToJSON;
exports.CastToJSONTyped = CastToJSONTyped;
const runtime_1 = require("../runtime");
function CastFromJSON(json) {
    return CastFromJSONTyped(json, false);
}
function CastFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'tag': !(0, runtime_1.exists)(json, 'tag') ? undefined : json['tag'],
        'url': !(0, runtime_1.exists)(json, 'url') ? undefined : json['url'],
        'tagColor': !(0, runtime_1.exists)(json, 'tagColor') ? undefined : json['tagColor'],
    };
}
function CastToJSON(value) {
    return CastToJSONTyped(value, false);
}
function CastToJSONTyped(value, ignoreDiscriminator = false) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'tag': value.tag,
        'url': value.url,
        'tagColor': value.tagColor,
    };
}
